import { useMutation, useQueryClient } from 'react-query';
import request from '../../../helpers/request';
import { queryKeys } from '../queries/queryKeys';
import { useSelector } from 'react-redux';
import { documentDrawerSelector } from '../store/selectors/new-document.selector';
import { attachmentsActions } from '../../../actions/attachments.actions';

const addDocsAttachFile = async ({ docId, files }) => {
  return await Promise.allSettled(
    files.map((file) => {
      const formData = new FormData();
      formData.append('file', file.originFileObj);

      return request.post(
        `/Docs/attach_file/${docId}`,
        formData,
        `При загрузке файла ${file.originFileObj.name} произошла ошибка`,
        'Error'
      );
    })
  );
};

const useAddDocsAttachFile = () => {
  const queryClient = useQueryClient();

  const { mode } = useSelector(documentDrawerSelector);

  const mutation = useMutation(addDocsAttachFile, {
    onSuccess: (data, { docId }) => {
      if (data === 'Error') return;

      queryClient.invalidateQueries(queryKeys.docsAttachments(docId));

      if (mode === 'edit') {
        attachmentsActions.fetchAttachments(docId, 'documents');
      }
    },
  });

  return {
    isLoading: mutation.isLoading,
    onMutation: mutation.mutateAsync,
  };
};

export default useAddDocsAttachFile;
